import { Suspense, useEffect } from "react";
import Router from "./routes";
import UXloader from "./components/layouts/UXloader";
import { BrowserRouter } from "react-router-dom";
import UXErrorBoundary from "./components/layouts/UXErrorBoundary";
import { PlatformFeedbackProvider } from "./components/platform-feedback/PlatformFeedbackProvider";
import PlatformFeedbackPortal from "./components/platform-feedback/PlatformFeedbackPortal";
import { FONTS } from "./actions/constants";
import { TestPreviewWidgetProvider } from "./components/test-preview/TestPreviewWidgetProvider";

export default function App() {
  useEffect(() => {
    if (!document.getElementById("quill-font-tester-auto-css")) {
      const style = document.createElement("style");
      style.id = "quill-font-tester-auto-css";

      const css = FONTS.map(({ value, css }) => {
        return `.ql-font-${value} { font-family: ${css} !important; }`;
      }).join("\n");

      style.textContent = css;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <Suspense fallback={<UXloader />}>
      <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
        <UXErrorBoundary>
          <PlatformFeedbackProvider>
            <TestPreviewWidgetProvider>
              <Router />
            </TestPreviewWidgetProvider>
            <PlatformFeedbackPortal />
          </PlatformFeedbackProvider>
        </UXErrorBoundary>
      </BrowserRouter>
    </Suspense>
  );
}
